import { render, staticRenderFns } from "./AdminAddUsers.vue?vue&type=template&id=12f04a00&"
import script from "./AdminAddUsers.vue?vue&type=script&lang=js&"
export * from "./AdminAddUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports